export default __webpack_public_path__ + "static/media/no-itin.3edb90aa.png";